var React = require('react');

function Show (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"style":{"fill":"none","stroke":"#1797E5","strokeWidth":"3.575","strokeLinecap":"round","strokeLinejoin":"round"},"points":"33.73,13.14 \n\t20,26.86 6.27,13.14 "}));
}

Show.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = Show;

Show.default = Show;
